import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { SelectCompanyBase } from '../HousingStock/components/ui/MainHeader/components/SelectCompany';

export const SelectCompany = ({ companyId, companies, onChange, disabled }) => {
  useEffect(() => {
    if (companies?.length === 1) {
      onChange(companies[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(companies)]);

  const wrappedOnChange = (payload) => {
    onChange(payload?.item.id || undefined);
  };

  return (
    <SelectCompanyBase
      currentCompany={companies.find((c) => c.id === companyId)}
      companies={companies || []}
      onChange={wrappedOnChange}
      btnProps={null}
      disabled={disabled || companies?.length === 1}
    />
  );
};

const CompanyItem = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});

SelectCompany.propTypes = {
  company: PropTypes.number,
  companies: PropTypes.arrayOf(CompanyItem).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};
